export default __webpack_public_path__ + "static/media/afl3.d4db5bb9.svg";